import OrderPromoSummary from '../../promo/OrderPromoSummary';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const OrdersTabMobile = ({ orders }) => {
  const [expandedOrders, setExpandedOrders] = useState({});

  const toggleDeliveryExpanded = (orderId) => {
    setExpandedOrders(prev => ({
      ...prev,
      [orderId]: !prev[orderId]
    }));
  };

  const getShortDeliveryInfo = (order) => {
    if (!order.userInfo) return '';
    
    if (order.userInfo.receiveMethod && order.userInfo.receiveMethod.description) {
      return order.userInfo.receiveMethod.description;
    }
    
    return order.deliveryMethod || '';
  };

  const getFullDeliveryInfo = (order) => {
    if (!order.userInfo) return null;
    
    if (order.userInfo.receiveMethod && order.userInfo.receiveMethod.id === 3) {
      return null; // Для самовивізу повна інформація не потрібна
    }
    
    const details = [];
    if (order.userInfo.receiveMethod && order.userInfo.receiveMethod.description) {
      details.push(`Спосіб доставки: ${order.userInfo.receiveMethod.description}`);
    }
    if (order.userInfo.name && order.userInfo.surname) {
      details.push(`Отримувач: ${order.userInfo.name} ${order.userInfo.surname}`);
    }
    if (order.userInfo.phone) {
      details.push(`Телефон: ${order.userInfo.phone}`);
    }
    if (order.userInfo.city) {
      details.push(`Місто: ${order.userInfo.city}`);
    }
    if (order.userInfo.departmentNumber) {
      details.push(`Відділення: ${order.userInfo.departmentNumber}`);
    }
    if (order.userInfo.street) {
      details.push(`Вулиця: ${order.userInfo.street}`);
    }
    if (order.userInfo.buildingNumber) {
      details.push(`Будинок: ${order.userInfo.buildingNumber}`);
    }
    if (order.userInfo.flatNumber) {
      details.push(`Квартира: ${order.userInfo.flatNumber}`);
    }
    return details;
  };
  const formatCurrency = (amount) => {
    if (!amount) return "0грн";
    return `${amount.toLocaleString("uk-UA")}грн`;
  };

  const getOrderStatusColor = (orderStatus) => {
    const statusColorMap = {
      "Очікує на обробку": "#2F80ED",
      "Підтверджено, очікує на пакування": "#56CCF2",
      "Упаковано, очікує на відправлення": "#2D9CDB",
      "Відправлено": "#27AE60",
      "Передзамовлення": "#27AE60", // Зелений (як на сторінці товару, в кошику та підтвердженні)
      "Відкладено": "#F2C94C",
      "Відмінено": "#EB5757",
      "Повернено": "#EB5757",
    };
    return statusColorMap[orderStatus] || "#6C757D";
  };

  const getOrderStatusIcon = (orderStatus) => {
    const statusIconMap = {
      "Очікує на обробку": "bi-clock",
      "Підтверджено, очікує на пакування": "bi-check-circle",
      "Упаковано, очікує на відправлення": "bi-box-seam",
      "Відправлено": "bi-truck",
      "Передзамовлення": "bi-calendar-check",
      "Відкладено": "bi-pause-circle",
      "Відмінено": "bi-x-circle",
      "Повернено": "bi-arrow-counterclockwise",
    };
    return statusIconMap[orderStatus] || "bi-circle";
  };

  const getPaymentStatusColor = (paymentStatus) => {
    if (paymentStatus === "Оплачений" || paymentStatus === "Оплата при отриманні") {
      return "#27AE60";
    }
    return "#E0A800";
  };

  if (!orders || orders.length === 0) {
    return (
      <div className="text-center p-4">
        <p>Замовлень не знайдено</p>
      </div>
    );
  }

  return (
    <div>
      {orders.map((order) => (
        <div key={order.orderId}>
          <div className="card mb-3">
            <div className="card-body">
              {/* Перший рядок: Номер замовлення і дата */}
              <div className="d-flex justify-content-between align-items-center mb-1">
                <strong>{order.orderId}</strong>
                <small className="text-muted">{order.createTime}</small>
              </div>
              
              {/* Другий рядок: Статус */}
              <div className="mb-3 pb-1" style={{ borderBottom: '1px solid #e9ecef' }}>
                <strong style={{ color: getOrderStatusColor(order.orderStatus), fontSize: '0.95rem' }}>
                  <i className={`bi ${getOrderStatusIcon(order.orderStatus)} mr-1`}></i>
                  {order.orderStatus}
                </strong>
              </div>

              {/* Блоки інформації */}
              <div className="mb-3">
                {/* Сума */}
                <div className="mb-3 pb-1" style={{ borderBottom: '1px solid #e9ecef' }}>
                  <small className="text-muted">Сума</small>
                  <div>
                    {order.totalPrice !== order.discountedPrice ? (
                      <>
                        <span className="text-decoration-line-through text-muted mr-2">
                          {formatCurrency(order.totalPrice)}
                        </span>
                        <strong>{formatCurrency(order.discountedPrice)}</strong>
                      </>
                    ) : (
                      <strong>{formatCurrency(order.discountedPrice)}</strong>
                    )}
                  </div>
                  <OrderPromoSummary order={order} />
                </div>

                {/* Оплата */}
                <div className="mb-3 pb-1" style={{ borderBottom: '1px solid #e9ecef' }}>
                  <small className="text-muted">Оплата</small>
                  <div>
                    <span>{order.paymentType}</span>
                    {order.paymentType !== "Оплата при отриманні" && (
                      <span className="ml-2">
                        {order.paymentStatus === "Оплачений" ? (
                          <strong style={{ color: getPaymentStatusColor(order.paymentStatus), fontSize: "0.875rem" }}>
                            <i className="bi bi-check-circle-fill mr-1" style={{ color: "#27AE60", fontSize: "0.875rem" }}></i>
                            {order.paymentStatus}
                          </strong>
                        ) : (
                          <strong style={{ color: getPaymentStatusColor(order.paymentStatus), fontSize: "0.875rem" }}>
                            <i className="bi bi-clock mr-1" style={{ color: "#E0A800", fontSize: "0.875rem" }}></i>
                            {order.paymentStatus}
                          </strong>
                        )}
                      </span>
                    )}
                  </div>
                </div>

                {/* Доставка */}
                {order.userInfo && (
                  <div className="mb-3 pb-1" style={{ borderBottom: '1px solid #e9ecef' }}>
                    <small className="text-muted">Доставка</small>
                    {expandedOrders[order.orderId] ? (
                      <div>
                        <div className="d-flex align-items-start">
                          <div className="flex-grow-1 text-muted" style={{ fontSize: '0.875rem' }}>
                            {getFullDeliveryInfo(order) && getFullDeliveryInfo(order).map((detail, idx) => (
                              <div key={idx}>{detail}</div>
                            ))}
                          </div>
                          {getFullDeliveryInfo(order) && getFullDeliveryInfo(order).length > 0 && (
                            <i 
                              className="bi bi-chevron-up ml-2"
                              style={{ cursor: 'pointer', fontSize: '0.75rem', flexShrink: 0, marginTop: '2px' }}
                              onClick={() => toggleDeliveryExpanded(order.orderId)}
                            ></i>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <span className={order.userInfo.receiveMethod && order.userInfo.receiveMethod.id === 3 ? "" : "text-truncate"}>
                          {getShortDeliveryInfo(order)}
                        </span>
                        {getFullDeliveryInfo(order) && getFullDeliveryInfo(order).length > 0 && (
                          <i 
                            className="bi bi-chevron-down ml-2"
                            style={{ cursor: 'pointer', fontSize: '0.75rem', flexShrink: 0 }}
                            onClick={() => toggleDeliveryExpanded(order.orderId)}
                          ></i>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Трекінг-номер */}
                {order.trackingNumber && (
                  <div className="mb-3 pb-1" style={{ borderBottom: '1px solid #e9ecef' }}>
                    <small className="text-muted mr-2">
                      <i className="bi bi-upc mr-1"></i>
                      Трекінг-номер:
                    </small>
                    <span
                      onClick={() => window.open(`https://novaposhta.ua/tracking/${order.trackingNumber}`, '_blank')}
                      style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}
                    >
                      <strong style={{ color: '#000' }}>
                        {order.trackingNumber}
                      </strong>
                      <i className="bi bi-box-arrow-up-right" style={{ fontSize: '0.875rem', color: '#000' }}></i>
                    </span>
                  </div>
                )}
              </div>

              {/* Інформація про товари та кнопка Детальніше */}
              <div className="pt-1 d-flex justify-content-between align-items-center">
                {(order.distinctProductsCount || order.totalQuantity) && (
                  <div className="text-muted" style={{ fontSize: '0.875rem' }}>
                    {order.distinctProductsCount && (
                      <span>{order.distinctProductsCount} {order.distinctProductsCount === 1 ? 'найменування' : 'найменувань'}</span>
                    )}
                    {order.distinctProductsCount && order.totalQuantity && <span className="mx-2">•</span>}
                    {order.totalQuantity && (
                      <span>{order.totalQuantity} {order.totalQuantity === 1 ? 'шт' : 'шт'}</span>
                    )}
                  </div>
                )}
                <Link 
                  to={`/user/order/${order.orderId}`}
                  className="btn btn-link p-0" 
                  style={{ color: '#000', textDecoration: 'none' }}
                >
                  <strong>Детальніше</strong>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersTabMobile;
